export const DAY_IN_SECONDS = 24 * 60 * 60;
export const YEAR_IN_SECONDS = 365 * DAY_IN_SECONDS;
